import { observer } from 'mobx-react-lite'
import { Typography, Icon, Tooltip } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useEventConversationCalling } from 'widgets/ConversationMessages/ui/CallingContent/events/EventConversationCalling'
import { type CallingContentStore } from 'widgets/ConversationMessages/ui/CallingContent/store/CallingContentStore'
import styles from './styles.module.scss'

type ICallingContentProps = {
  store: CallingContentStore
}

export const CallingContent = observer(({ store }: ICallingContentProps) => {
  const { usersStore } = useEntitiesContext()

  useEventConversationCalling(store)

  if (!store.callingsCount) return null

  const content = () => {
    if (store.callingsCount === 1) {
      const calling = store.callings[0]
      const user = usersStore.getItem(calling.userId)

      const visibleName = user ? user.first_name : calling.first_name
      const fullName = user ? user.displayInfo : `${calling.first_name} ${calling.last_name}`.trim()

      return (
        <>
          On a call with{' '}
          <Tooltip placement={'top'} label={fullName}>
            <span className={styles.visibleName}>{visibleName}</span>
          </Tooltip>
        </>
      )
    }

    return `${store.callingsCount} members are on a call`
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.content}>
        <Icon icon='phoneRing' tertiary />
        <Typography
          variant={'body-md-regular'}
          ariaLabel={'on-the-call'}
          color={'var(--content-primary-tertiary)'}
        >
          {content()}
        </Typography>
      </div>
    </div>
  )
})
